import './Testimony.css';
import FlexPair from '../FlexPair/FlexPair.js';
import { IMAGE_TEXT_GAP, MOBILE_IMAGE_TEXT_GAP } from '../../utils/Constants.js';

const Testimony = ({ officerName, officerTitle, officerImage, officerTestimony, officerAttributesList, officerInterestsList, inverted }) => {
	const officerAttributes = (
		<div className="officer-list">
			<h4>Attributes</h4>
			<ul>
				{officerAttributesList && officerAttributesList.map((item, index) => (
					<li key={index}>{item}</li>
				))}
			</ul>
		</div>
	);
	const officerInterests = (
		<div className="officer-list">
			<h4>Interests</h4>
			<ul>
				{officerInterestsList && officerInterestsList.map((item, index) => (
					<li key={index}>{item}</li>
				))}
			</ul>
		</div>
	);
	return (
		<div className={`officer-wrapper ${inverted ? 'inverted' : ''}`}>
			<div className="officer-bust">
				<img className={inverted ? 'inverted' : ''} src={officerImage} alt={`${officerName} Bust`} />
			</div>
			<div className="officer-testimony">
				<h2>{officerName}</h2>
				<h4>{officerTitle}</h4>
				{officerTestimony}
				<FlexPair leftContent={officerAttributes} rightContent={officerInterests} pcGap={IMAGE_TEXT_GAP} mobileGap={MOBILE_IMAGE_TEXT_GAP} verticallyCentered={false} />
			</div>
		</div>
	);
};

export default Testimony;